import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const TitleWrapper = styled.div`
  height: 50px;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${ColorSF2.paleBlue};
  padding: 0 10px;
  font-weight: bold;
  @media (max-height: 530px) {
    height: 30px;
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  color: ${ColorSF2.black};
`;
export const TitleAndUpdatedAt = styled.div`
  display: flex;
  align-items: center;
`;

export const ActionGroup = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderLabel = styled.span`
  margin-left: 10px;
  font-weight: 100;
  font-size: 12px;
  color: #211106;
`;

export const SelectBox = styled.div`
  margin-left: 10px;
  color: ${ColorSF2.black};
`;

export const SelectExecute = styled.select`
  width: 120px;
  color: ${ColorSF2.white};
  &.selected {
    color: ${ColorSF2.black};
  }
`;
